import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '#pplx/frontend/aether/components/Icon/index.js';
import { enterpriseProOnboardingStartedEvent } from '#pplx/frontend/apps/ask/events/enterprise-onboarding/analytics.js';
import { sidebarMenuItemClickedEvent } from '#pplx/frontend/apps/ask/events/sidebar/analytics.js';
import { SidebarBottomItem } from '#pplx/frontend/apps/ask/layout/sidebar/core/shared/SidebarBottomItem.js';
import { ENTERPRISE_ONBOARDING_HOME_URL } from '#pplx/frontend/apps/ask/organization/utils/enterpriseOnboarding.js';
import { ModalOrigin } from '#pplx/frontend/components/types/types.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { useRouter } from '#pplx/frontend/router/provider.js';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
export const SidebarTeamInviteButton = ({ isExpanded, }) => {
    const { $t } = useIntl();
    const { track } = useInstrumentation();
    const router = useRouter();
    const label = $t({
        defaultMessage: 'Add your team',
        description: 'Sidebar button label to open the enterprise pricing modal for Pro subscribers',
        id: '02bf239911',
    });
    const trackClick = useCallback(() => {
        track(sidebarMenuItemClickedEvent({
            name: 'sidebar menu item clicked',
            data: {
                tabType: 'add team',
                location: 'sidebar',
            },
        }));
    }, [track]);
    const handleClick = useCallback(() => {
        trackClick();
        track(enterpriseProOnboardingStartedEvent({
            name: 'enterprise pro onboarding started',
            data: {
                origin: ModalOrigin.SIDEBAR_TEAM_INVITE,
            },
        }));
        router.push(ENTERPRISE_ONBOARDING_HOME_URL);
    }, [router, trackClick, track]);
    return (_jsx(SidebarBottomItem.Root, { isExpanded: isExpanded, children: _jsx(SidebarBottomItem.Leading, { tooltip: label, label: label, onClick: handleClick, children: _jsx(Icon, { icon: $icon('user-plus'), size: "medium" }) }) }));
};
//# sourceMappingURL=SidebarTeamInviteButton.js.map